import { render, staticRenderFns } from "./now-playing.vue?vue&type=template&id=3c3a95cc"
import script from "./now-playing.vue?vue&type=script&lang=js"
export * from "./now-playing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports